import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTeamFromCookies } from "../../../../utils/Auth";
import { getABusinessSettings } from "../../../../redux/businessSettings/businessSettingsActions";

export default function OutletDashboardSummary() {
  const dispatch = useDispatch();
  const { businessSettings } = useSelector((state) => state.businessSettings);

  const team = getTeamFromCookies();

  const [payLoad] = useState({
    business_id: team,
  });

  useEffect(() => {
    dispatch(getABusinessSettings(payLoad?.business_id));
  }, [dispatch, payLoad?.business_id]);

  return (
    <div className="grid grid-col-1 md:grid-cols-2 gap-4 mt-12">
      <div className="px-3 py-4 sm:px-8 sm:py-8 border dark:border-none bg-white dark:bg-[#121212] rounded-md">
        <div className="flex justify-between items-center mb-4">
          <span className="text-[#344B67] dark:text-[#FFFFFF] font-bold">
            Currency
          </span>
          <span className="text-[#344B67] dark:text-white font-bold capitalize">
            {businessSettings?.currency}
          </span>
        </div>
        <div className="flex justify-between items-center mb-4">
          <span className="text-[#344B67] dark:text-[#FFFFFF] font-bold">
            Insurance Percentage
          </span>
          <span className="text-[#344B67] dark:text-white font-bold capitalize">
            {businessSettings?.insurance_percentage}%
          </span>
        </div>
        <div className="flex justify-between items-center mb-4">
          <span className="text-[#344B67] dark:text-[#FFFFFF] font-bold">
            Tax Percentage
          </span>
          <span className="text-[#344B67] dark:text-white font-bold capitalize">
            {businessSettings?.tax_percentage}%
          </span>
        </div>
      </div>

      <div className="px-3 py-4 sm:px-8 sm:py-8 border dark:border-none bg-white dark:bg-[#121212] rounded-md">
        <div className="flex justify-between items-center mb-4">
          <span className="text-[#344B67] dark:text-[#FFFFFF] font-bold">
            VAT Percentage
          </span>
          <span className="text-[#344B67] dark:text-white font-bold capitalize">
            {businessSettings?.vat_percentage}%
          </span>
        </div>
        <div className="flex justify-between items-center mb-4">
          <span className="text-[#344B67] dark:text-[#FFFFFF] font-bold">
            Discount Percentage
          </span>
          <span className="text-[#344B67] dark:text-white font-bold capitalize">
            {businessSettings?.discount_percentage}%
          </span>
        </div>
        {/* <div className="flex justify-between items-center mb-4">
          <span className="text-[#344B67] font-bold">Discount Amount</span>
          <span className="text-[#344B67] font-bold capitalize">
            {businessSettings?.discount_amount}
          </span>
        </div> */}
      </div>
    </div>
  );
}
